// Upload service cho REST API
const API_REST_URL = process.env.NEXT_PUBLIC_API_REST_URL || ''

export interface IUploadResponse {
  url: string
  size: number
  type: string
  file_name: string
  path: string
}

export interface IUploadResult {
  success: boolean
  data?: IUploadResponse
  message?: string
}

/**
 * Upload file (ảnh hoặc video) lên server
 * @param file - File cần upload
 * @param module - Module name (mặc định: 'image')
 * @returns Promise với response chứa path và url của file
 */
export const uploadFileRestAPI = async ({
  file,
  module = 'image',
}: {
  file: File
  module?: string
}): Promise<IUploadResult> => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('module', module)

    const response = await fetch(`${API_REST_URL}/mona/file/upload`, {
      method: 'POST',
      headers: {
        accept: '*/*',
        'cache-control': 'no-cache',
        pragma: 'no-cache',
      },
      body: formData,
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result: IUploadResponse = await response.json()

    // API trả về trực tiếp data, không có field success
    // Check nếu có path thì coi như thành công
    if (result.path) {
      return {
        success: true,
        data: result,
      }
    } else {
      return {
        success: false,
        message: 'Upload thất bại: không nhận được path',
      }
    }
  } catch (error) {
    console.error('Upload file error:', error)
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Upload thất bại',
    }
  }
}

/**
 * Upload nhiều files cùng lúc
 * @param files - Danh sách files cần upload
 * @param module - Module name
 * @returns Promise với danh sách URLs
 */
export const uploadMultipleFilesRestAPI = async ({
  files,
  module = 'image',
}: {
  files: File[]
  module?: string
}): Promise<string[]> => {
  const uploadPromises = files.map((file) => uploadFileRestAPI({ file, module }))

  const results = await Promise.all(uploadPromises)

  const urls: string[] = []
  results.forEach((result, index) => {
    if (result.success && result.data?.path) {
      // Sử dụng path từ response
      urls.push(result.data.url)
    } else {
      console.error(`Upload file ${files[index].name} failed:`, result.message)
    }
  })

  return urls
}
